<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :filterData="scopedFilterData"
      :apiUrl="apiUrl">

      <template #form="scope">
        <div class="form-group">
          <label>Kategori barang / No. Rekening</label>
          <v-select
            placeholder="Pilih rekening/kategori barang"
            v-model="scope.data.AccountancySubcategoryID"
            :options="listAccountancySubcategories"
            @search="fetchAccountancySubcategoryOptions"
            :reduce="item => item.ID"
            :getOptionLabel="opt => opt.Code ? `${opt.Code} - ${opt.Name}` : opt.Name">

            <template #option="opt">
              <em>{{ opt.AccountancyCategory.Name }}</em>
              <p class="font-weight-bold m-0">{{ opt.Code ? `${opt.Code} - ${opt.Name}` : opt.Name }}</p>
            </template>

            <template #no-options="{ search }">
              <span v-show="search.length < 3">Input min. 3 huruf</span>
              <span v-show="search.length >= 3">Tidak ditemukan</span>
            </template>
          </v-select>
        </div>

        <div class="form-group">
          <label>Nama Barang</label>
          <input class="form-control d-block w-100" v-model="scope.data.Name">
        </div>

        <div class="form-group">
          <label>Kategori Aset</label>
          <v-select
            placeholder="untuk barang aset (kosongi jika barang bukan aset)"
            v-model="scope.data.LogisticSubcategoryID"
            :options="listLogisticCategories"
            @search="fetchLogisticSubcategoryOptions"
            :reduce="item => item.ID"
            :getOptionLabel="opt => opt.Code ? `${opt.Code} - ${opt.Name}` : opt.Name">

            <template #option="opt">
              <em>{{ opt.LogisticCategory.Name }}</em>
              <p class="font-weight-bold m-0">{{ opt.Code ? `${opt.Code} - ${opt.Name}` : opt.Name }}</p>
            </template>

            <template #no-options="{ search }">
              <span v-show="search.length < 3">Input min. 3 huruf</span>
              <span v-show="search.length >= 3">Tidak ditemukan</span>
            </template>
          </v-select>
        </div>

        <div class="form-group">
          <label>Satuan</label>
          <v-select
            v-model="scope.data.LogisticItemUnitID"
            :options="listLogisticItemUnits"
            :reduce="item => item.ID"
            :getOptionLabel="opt => opt.Unit + ' | ' + opt.DistributionUnit"/>
        </div>

        <div class="form-group">
          <label>Harga Pokok</label>
          <input class="form-control d-block w-100" v-model.number="scope.data.Price">
        </div>

        <button class="btn btn-primary btn-sm btn-block" type="submit">Simpan</button>
      </template>

      <template #filter="scope">
        <div class="row">
          <div class="col">
            <v-select
              placeholder="Rekening barang"
              v-model="scope.data.accountancySubcategoryId"
              :options="listAccountancySubcategories"
              @search="fetchAccountancySubcategoryOptions"
              @input="onRefresh"
              :reduce="item => item.ID"
              :getOptionLabel="opt => opt.Code ? `${opt.Code} - ${opt.Name}` : opt.Name">

              <template #option="opt">
                <em>{{ opt.AccountancyCategory.Name }}</em>
                <p class="font-weight-bold m-0">{{ opt.Code ? `${opt.Code} - ${opt.Name}` : opt.Name }}</p>
              </template>

              <template #no-options="{ search }">
                <span v-show="search.length < 3">Input min. 3 huruf</span>
                <span v-show="search.length >= 3">Tidak ditemukan</span>
              </template>
            </v-select>
          </div>

          <div class="col">
            <v-select
              placeholder="Kategori Aset"
              v-model="scope.data.logisticSubcategoryId"
              :options="listLogisticCategories"
              @search="fetchLogisticSubcategoryOptions"
              @input="onRefresh"
              :reduce="item => item.ID"
              :getOptionLabel="opt => opt.Code ? `${opt.Code} - ${opt.Name}` : opt.Name">

              <template #option="opt">
                <em>{{ opt.LogisticCategory.Name }}</em>
                <p class="font-weight-bold m-0">{{ opt.Code ? `${opt.Code} - ${opt.Name}` : opt.Name }}</p>
              </template>

              <template #no-options="{ search }">
                <span v-show="search.length < 3">Input min. 3 huruf</span>
                <span v-show="search.length >= 3">Tidak ditemukan</span>
              </template>
            </v-select>
          </div>
          
        </div>
      </template>

    </AppToolbox>

    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :filter="scopedFilterData"
      :search="search"
      @onSelectItem="selectedItem = $event" />
  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.fetchOptionData()
  },
  data() {
    return {
      apiUrl: '/logistic-item',
      tableFields: [
        { key: 'index', label: 'No.' },
        // { key: 'Code', label: 'Kode Barang' },
        { key: 'AccountancySubcategory', label: 'Rekening', formatter: value => value.Name },
        { key: 'Name', label: 'Nama Barang' },
        { key: 'LogisticItemUnit', label: 'Satuan', formatter: value => value ? value.Unit : '' },
        { key: 'LogisticSubcategory', label: 'Aset', formatter: value => {
          if (value.Name) {
            return value.Name
          } else {
            return '<span class="badge badge-secondary">Bukan barang aset</span>'
          }
        }},
        // { key: 'Price', label: 'Harga Pokok', formatter: value => this.$helper.formatRupiah(value) }
      ],
      selectedItem: null,
      search: '',
      scopedFormData: {
        ID: null,
        Code: '',
        Name: '',
        LogisticItemUnitID: null,
        AccountancySubcategoryID: null,
        LogisticSubcategoryID: null,
        Price: null
      },
      scopedFilterData: {
        accountancySubcategoryId: null,
        logisticSubcategoryId: null
      },
      listLogisticItemUnits: [],
      listLogisticCategories: [],
      listAccountancySubcategories: []
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },

    fetchOptionData () {
      this.$axios.all([
        this.$axios.get('/logistic-item-unit'),
      ]).then(this.$axios.spread((...res) => {
        this.listLogisticItemUnits = res[0].data
      }))
    },

    fetchAccountancySubcategoryOptions (search, loading) {
      if (search.length >= 3) {
        loading(true)

        this.$axios.get('/accountancy-subcategory?search=' + search).then(res => {
          this.listAccountancySubcategories = res.data

          loading(false)
        })
      } else {
        // if (!this.scopedFormData.AccountancySubcategoryID) {
        //   this.listAccountancySubcategories = []
        // }
      }
    },

    fetchLogisticSubcategoryOptions (search, loading) {
      if (search.length >= 3) {
        loading(true)

        this.$axios.get('/logistic-subcategory?search=' + search).then(res => {
          this.listLogisticCategories = res.data

          loading(false)
        })
      } else {
        // if (!this.scopedFormData.LogisticSubcategoryID) {
        //   this.listLogisticCategories = []
        // }
      }
    }
  }
}
</script>
